"use strict";
(function() {

  // Toolbox v2

  const config = (function() {
    var isDebug = document.cookie.indexOf("debugTimestamp=1") !== -1;

    var m = ($("link[href*=frontend_master]").attr("href") || "").match(/^(.+)\/user\/temp\/.+$/),
      cdnPath = m ? m[1] : "";

    return {
      cdnPath,
      snippetPath: cdnPath + "/user/documents/upload/snippets/",
      cacheBusterParam: "v",
      cacheBuster: null,
      cacheLifetime: 5 * 60000,
      noCache: isDebug,
      tabletSlickBreakpoint: shoptet.config.breakpoints.lg,
      mobileSlickBreakpoint: shoptet.config.breakpoints.sm,
    };
  })();

  const common = (function() {
    function constant(val) {
      return function() {
        return val;
      };
    }

    function identity(val) {
      return val;
    }

    function property(key) {
      return function(obj) {
        return obj[key];
      };
    }

    function matcher(key, value) {
      if(typeof key !== "object")
        return function(obj) {
          return obj[key] === value;
        };

      return function(obj) {
        for(let k in key)
          if(obj[k] !== key[k])
            return false;
        return true;
      };
    }

    function find(arr, predicate) {
      for(let i = 0; i < arr.length; i++)
        if(predicate(arr[i], i))
          return arr[i];
      return null;
    }

    function findIndex(arr, predicate) {
      for(let i = 0; i < arr.length; i++)
        if(predicate(arr[i], i))
          return i;
      return -1;
    }

    function indexBy(arr, iteratee) {
      var obj = {};
      for(let i = 0; i < arr.length; i++)
        obj[iteratee(arr[i], i)] = arr[i];
      return obj;
    }

    function groupBy(arr, iteratee) {
      const obj = {};
      for(let i = 0; i < arr.length; i++) {
        const key = iteratee(arr[i], i);
        if(!obj[key]) obj[key] = [];
        obj[key].push(arr[i]);
      }
      return obj;
    }

    function isObject(obj) {
      const type = typeof obj;
      return type === "function" || (type === "object" && !!obj);
    }

    function isPlainObject(obj) {
      if(!isObject(obj))
        return false;
      const proto = Object.getPrototypeOf(obj);
      return proto === null || proto === Object.prototype;
    }

    function isString(obj) {
      return Object.prototype.toString.call(obj) === "[object String]";
    }

    function iteratee$(fn, context) {
      return function() {
        const res = fn.apply(context !== undefined ? context : this, [$(this), ...arguments]);
        return (res instanceof $) ? res.get() : res;
      };
    }

    function assignDeep(targetObj) {
      for(let i = 1; i < arguments.length; i++) {
        const sourceObj = arguments[i];

        for(let key in sourceObj) {
          const value = sourceObj[key];
          if(isPlainObject(targetObj[key])) {
            if(!isPlainObject(value))
              throw new Error("Cannot extend plain object with value of different type.");
            assignDeep(targetObj[key], value);
          } else
            targetObj[key] = value;
        }
      }
      return targetObj;
    }

    function parseNumber(str) {
      return parseFloat(("" + str).replace(/\s+/g, "").replace(",", "."));
    }

    function parsePrice(str) {
      return parseNumber(("" + str).replace(shoptet.config.currencySymbol, "").replace(/(od|ab)\s/, ""));
    }

    function pluralize(n, form1, form24, formMore) {
      n = Math.abs(n);
      return n === 1 ? form1 : (n >= 2 && n <= 4) ? form24 : formMore;
    }

    function slugify(str) {
      const letters = str.trim()
        .toLowerCase()
        .split(""); // Split to array of letters

      const transFrom = "ěščřžýáíéďťóúůňďť";
      const transTo = "escrzyaiedtouundt";
      for(let index, j = 0; j < letters.length; j++) {
        if((index = transFrom.indexOf(letters[j])) !== -1)
          letters[j] = transTo[index];
      }

      return letters
        .join("")
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/-+/g, '-');
    }

    function getProperty(obj, path) {
      return path.split(".").reduce(function(cur, key) {
        if(cur === undefined)
          return cur;
        return cur[key];
      }, obj);
    }

    function setProperty(obj, path, value) {
      var parts = path.split("."),
        key;
      while(key = parts.shift()) {
        if(!parts.length) // key is last
          obj[key] = value;
        else
          obj = obj[key];
      }
    }

    function once(fn) {
      var done = false;
      return function() {
        if(done)
          return;
        done = true;
        return fn.apply(this, arguments);
      };
    }

    function debounce(func, wait) {
      var timeout;
      return function() {
        var args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
          func.apply({}, args);
        }, wait);
      };
    }

    function throttle(func, wait) {
      var lastCall = 0, lastResult;

      return function() {
        var now = Date.now();
        if(now - lastCall < wait)
          return lastResult;
        lastCall = now;
        return lastResult = func.apply({}, arguments);
      };
    }

    function promiseTry(f) {
      try {
        return Promise.resolve(f());
      } catch(err) {
        return Promise.reject(err);
      }
    }

    function memoize(cacheKeyResolver, callback, storage = window.sessionStorage) {
      function resolveKey(resolver, args, context) {
        let resolvedKey;
        if(typeof resolver === "function")
          resolvedKey = resolver.apply(context, args);
        else
          resolvedKey = resolver;

        if(Array.isArray(resolvedKey))
          resolvedKey = resolvedKey.map(resolver => resolveKey(resolver, args, context)).join(".");
        else if(!isString(resolvedKey))
          resolvedKey = JSON.stringify(resolvedKey);
        else
          resolvedKey = "" + resolvedKey;

        return resolvedKey;
      }

      const pendingPromises = Object.create({});
      return function(...args) {
        const context = this;
        const cacheKey = resolveKey(cacheKeyResolver, arguments, this);
        if(pendingPromises[cacheKey])
          return pendingPromises[cacheKey];
        let cachedValue = storage?.getItem(cacheKey);
        if(!config.noCache && cachedValue != null) {
          cachedValue = JSON.parse(cachedValue);
          if(cachedValue && cachedValue.t && Date.now() <= cachedValue.t + config.cacheLifetime)
            return Promise.resolve(cachedValue.v);
        }

        const promise = promiseTry(() => callback.apply(context, args)).then(function(result) {
          try {
            if(!config.noCache && cacheKey && storage)
              storage.setItem(cacheKey, JSON.stringify({ v: result, t: Date.now() }));
          } catch(err) {
            console.error("Unable to write cache key '" + cacheKey + "':", err);
          }

          return result;
        });

        pendingPromises[cacheKey] = promise;
        return promise;
      };
    }

    return {
      constant, identity, property, matcher, isPlainObject, isString,
      find, findIndex, indexBy, groupBy, iteratee$, assignDeep,
      parseNumber, parsePrice,
      pluralize, slugify,
      getProperty, setProperty,
      once, throttle, debounce,
      promiseTry, memoize,
    };
  })();

  const helpers = (function() {
    function getLocaleKey() {
      const dl = getShoptetDataLayer();
      return dl ? dl.language + "." + dl.currency : "";
    }

    function getStrings(moduleConfig) {
      const supportedLangs = Object.keys(moduleConfig.trans || {});
      if(!supportedLangs.length)
        throw new Error("No languages available (config.trans mising or empty)");
      if(supportedLangs.length > 1 && !moduleConfig.fallbackLang)
        throw new Error("config.fallbackLang is not set, but multiple languages are available.");
      const fallbackLang = moduleConfig.fallbackLang || supportedLangs[0];
      const dl = getShoptetDataLayer();
      const lang = dl ? dl.language : fallbackLang;
      return moduleConfig.trans[lang] || moduleConfig.trans[fallbackLang] || {};
    }

    function uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    }

    let idCounter = 0;
    function uniqueId(prefix) {
      const id = String(++idCounter);
      return prefix ? prefix + id : id;
    }

    return { getLocaleKey, getStrings, uniqueId, uuidv4, };
  })();

  const dom = (function() {
    function trimHtml($el) {
      $el = $($el);
      return $el.each(function() {
        $(this).html($(this).html().trim());
      });
    }

    function getTextShallow($el, noJoin) {
      $el = $($el);

      var parts = [];
      $el.contents().each(function() {
        if(this.nodeType === Node.TEXT_NODE)
          parts.push(this.data);
      });
      return noJoin ? parts : parts.join("");
    }

    function oneTime($el, key) {
      $el = $($el);
      key = "oneTime." + (key || "");
      if(!$el.length || $el.data(key))
        return false;
      $el.data(key, true);
      return true;
    }

    // return true only once if the contents of the given $el didn't change
    function oneTimeContents($el, key) {
      $el = $($el);
      key = "oneTimeContents." + (key || "");
      if(!$el.length)
        return false;
      for(let node of $el[0].childNodes) {
        if(node.nodeType === Node.COMMENT_NODE && node.textContent === key)
          return false;
      }
      $el.append(new Comment(key));
      return true;
    }

    function createModuleInitializer(options) {
      if(typeof options === "function")
        options = { domReady: options }; // compat
      return common.once(function init(throwInitErrors) {
        try {
          for(let dep of(options.dependencies || []))
            dep.init ? dep.init(true) : dep();
          if(options.earlyInit && options.earlyInit() === false)
            return;
          if(options.domReady)
            $(() => options.domReady());
          if(options.earlyRender)
            hooks.hookAfterDomLoad(options.earlyRender, true);
          if(options.render)
            hooks.hookAfterDomLoad(options.render, true);
          if(options.earlyRender)
            options.earlyRender();
        } catch(err) {
          const name = options.name || "<anonymous>";
          console.error(`Failed to initialize module ${name}`, err, options);
          if(throwInitErrors)
            throw err;
          return;
        }
      });
    }
    const whenReady = createModuleInitializer; // compat

    function waitForElement($parent, selector) {
      $parent = $($parent);
      return new Promise((resolve) => {
        if(!$parent.length)
          return;

        const $r = $parent.find(selector);
        if($r.length)
          return resolve($r);

        const obs = new MutationObserver((list) => {
          const $r = $parent.find(selector);
          if($r.length) {
            obs.disconnect();
            resolve($r);
          }
        });
        obs.observe($parent[0], { childList: true, subtree: true });
      });
    }

    function createElement(tagName, attrs, children) {
      var $el;
      if(tagName.charAt(0) === "<")
        $el = $(tagName);
      else {
        var parts = tagName.split(/([\.#]?[a-zA-Z0-9_:-]+)/).filter(function(part) { return part !== ""; });
        if(parts[0].match(/^\.|#/))
          tagName = "div";
        else
          tagName = parts.shift();
        $el = $(document.createElement(tagName))
        for(let part of parts) {
          if(part.charAt(0) === ".")
            $el.addClass(part.slice(1));
          else if(part.charAt(0) === "#")
            $el.prop("id", part.slice(1));
        }
      }

      if(!common.isPlainObject(attrs)) {
        children = attrs;
        attrs = {};
      }
      $el.attr(attrs);

      if(Array.isArray(children))
        $el.append(children.flat(Infinity));
      else if(children instanceof $)
        $el.append(children);
      else if(children !== undefined)
        $el.text(children);

      return $el;
    }

    function createTextNode(text) {
      return $(document.createTextNode(text));
    }

    function signalNativeChange($el) {
      $($el).each(function() {
        shoptet.scripts.signalNativeEvent("change", this);
      });
    }

    function $each($coll, iteratee) {
      return $($coll).each((i, el) => iteratee($(el), i));
    }

    function $eachOneTime($coll, iteratee, key) {
      return $each($coll, ($el, i) => void (oneTime($el, key) && iteratee($el, i)));
    }

    function $eachOneTimeContents($coll, iteratee, key) {
      return $each($coll, ($el, i) => void (oneTimeContents($el, key) && iteratee($el, i)));
    }

    function $map($coll, iteratee, unwrapJq = true) {
      return $($coll).map((i, el) => {
        const res = iteratee($(el), i);
        return unwrapJq && (res instanceof $) ? res.get() : res;
      });
    }

    function $filter($coll, iteratee) {
      return $($coll).filter((i, el) => iteratee($(el), i));
    }

    return {
      trimHtml,
      getTextShallow,
      oneTime, oneTimeContents,
      whenReady, waitForElement,
      createModuleInitializer,
      createElement, createTextNode,
      signalNativeChange,
      $each, $map, $filter,
      $eachOneTime, $eachOneTimeContents,
    }
  })(), $h = dom.createElement, $t = dom.createTextNode;

  const ajax = (function() {
    function appendCacheBuster(url) {
      if(!url || (!config.noCache && !config.cacheBuster))
        return url;
      var buster = config.cacheBusterParam + "=" + encodeURIComponent(String(config.noCache ? Date.now() : config.cacheBuster));
      if(url.indexOf("?") !== -1)
        return url + "&" + buster;
      return url + "?" + buster;
    }

    function loadTextNoCache(url) {
      return common.promiseTry(() => $.ajax({
        method: "GET",
        url,
        dataType: "text"
      })).catch(function(err) {
        if(!err)
          throw new Error("Falsy rejection while loading '" + url + "'.");
        if(!(err instanceof Error)) {
          const newErr = new Error("Non-Error rejection while loading '" + url + "': " + [err.readyState, err.status, err.statusText].join(" "));
          newErr.orig = err;
          throw newErr;
        }
        throw err;
      });
    }

    const loadTextCached = common.memoize(["ajaxCache", helpers.getLocaleKey, common.identity], loadTextNoCache);

    const ajaxGetCached = loadTextCached; // compat

    function loadText(url, noCache) {
      return Promise.resolve(noCache ? loadTextNoCache(url) : loadTextCached(url))
    }

    async function loadFragment(url, noCache) {
      return $(await loadText(url, noCache), shoptet.common.createDocumentFromString(""));
    }

    async function loadDocument(url, noCache) {
      return $(shoptet.common.createDocumentFromString(await loadText(url, noCache)));
    }

    function load(urls, loader, noCache) {
      if(!loader)
        loader = loadDocument;

      if(typeof urls === "string")
        return loader(urls);

      if(Array.isArray(urls)) { // deduplicate urls
        let promises = {};
        return Promise.all(urls.map(function(url) {
          if(!promises[url])
            promises[url] = loader(url, noCache);
          return promises[url];
        }));
      }

      var keys = Object.keys(urls),
        values = keys.map(function(key) {
          return urls[key];
        });

      return load(values, loader).then(function(payloads) {
        var result = {};
        for(var i = 0; i < keys.length; i++)
          result[keys[i]] = payloads[i];
        return result;
      });
    }

    function loadSnippets(urls, loader, noCache) {
      if(!loader)
        loader = loadFragment;

      return load(urls, function(url) {
        return loader(config.snippetPath + appendCacheBuster(url), noCache);
      });
    }

    function withSnippets(urls, callback) {
      return function() {
        var args = [].slice.call(arguments), context = this;
        loadSnippets(urls).then(function(snippets) {
          args.unshift(snippets);
          callback.apply(context, args);
        });
      };
    }

    function restoreShoptetCookies() {
      const language = getShoptetDataLayer().language;
      const currencyCode = getShoptetDataLayer().currency;
      document.cookie = "language=" + language + "; max-age=31536000; path=/; secure";
      document.cookie = "currencyCode=" + currencyCode + "; max-age=31536000; path=/; secure";
    }

    return {
      appendCacheBuster,
      ajaxGetCached,
      loadText, loadFragment, loadDocument,
      load,
      loadSnippets, withSnippets,
      restoreShoptetCookies,
    };
  })();

  const hooks = (function() {
    function hookFn(nameOrFn, callback) {
      var origFn = typeof nameOrFn === "string" ? common.getProperty(window, nameOrFn) : nameOrFn;
      if(typeof origFn !== "function") {
        console.error("Failed to hook " + nameOrFn + " (not a function)");
        return;
      }

      function patchedFn() {
        let calledOrigFn = false;
        try {
          return callback(function() {
            calledOrigFn = true;
            return origFn.apply(this, arguments);
          }, arguments, this);
        } catch(err) {
          if(!calledOrigFn) {
            console.error("Patched callback for", nameOrFn, "has thrown an exception before calling origFn: ", err);
            return origFn.apply(this, arguments);
          }
          throw err;
        }
      };
      patchedFn.origFn = origFn;

      if(typeof nameOrFn === "string")
        common.setProperty(window, nameOrFn, patchedFn);
      return patchedFn;
    }

    function hookAfterAjaxDone(url, callback) {
      var urlMatches;
      if(typeof url === "function")
        urlMatches = url;
      else if(url instanceof RegExp)
        urlMatches = function(_url) {
          return url.test(_url);
        };
      else
        urlMatches = function(_url) {
          return url === _url;
        };

      hookFn("$.ajax", function(oldAjax, args, context) {
        var options = args[0],
          ajaxResult = oldAjax.apply(context, args);
        if(urlMatches(options.url, options)) {
          ajaxResult.done = hookFn(ajaxResult.done, function(oldDone, args, context) {
            args = [].slice.call(args);
            args.push(function() {
              try {
                return callback.apply(this, arguments);
              } catch(err) {
                console.error("Ajax callback has thrown an exception:", err);
              }
            });
            return oldDone.apply(context, args);
          });
        }
        return ajaxResult;
      });
    }

    function hookAfterDomLoad(callback, native) {
      const events = ["ShoptetDOMContentLoaded", "ShoptetDOMContentChanged", "TDOMContentLoaded"];
      function handler(e) {
        try {
          callback.call(e ? e.target : null);
        } catch(err) {
          console.error("Dom load callback has thrown an exception:", err);
        }
      }
      for(let event of events)
        document.addEventListener(event, handler);
      if(native)
        $(() => handler());
    }

    function signalDomLoad(event, element) {
      var globalEvent = "TDOMContentLoaded";
      if(!event) {
        event = globalEvent;
        globalEvent = null;
      }
      shoptet.scripts.signal(event, element, null, globalEvent);
    }

    function hookAfterWindowResize(callback, debounceTime = 250) {
      const $w = $(window);
      function boundCallback() {
        try {
          callback($w.width());
        } catch(err) {
          console.error("Resize callback has thrown an exception:", err);
        }
      }
      $w.on("resize", debounceTime > 0 ? tb.common.debounce(boundCallback, debounceTime) : boundCallback);
      boundCallback();
    }

    function respond(query, onMatch, onUnmatch) {
      const media = matchMedia(query);
      let onUnmatch2, onMatch2, matches = null;
      function safeCall(f) {
        return typeof f === "function" ? f() : undefined;
      }
      function onChange(e) {
        const _matches = e.matches;
        if(matches === _matches)
          return;
        matches = _matches;
        if(matches) {
          safeCall(onMatch2), onMatch2 = null;
          onUnmatch2 = safeCall(onMatch);
        } else {
          safeCall(onUnmatch2), onUnmatch2 = null;
          onMatch2 = safeCall(onUnmatch);
        }
      }
      media.addEventListener("change", onChange);
      onChange(media);
    }

    /** @deprecated */
    function bindEvents(eventNames, callback, now, $el) {
      $el = $($el || document);
      if(!Array.isArray(eventNames))
        eventNames = [eventNames];
      for(let name of eventNames) {
        if(name === "ready")
          $(callback);
        else
          $el[0].addEventListener(name, callback);
      }
      if(now)
        callback();
    }

    return {
      hookFn,
      hookAfterAjaxDone,
      hookAfterDomLoad,
      signalDomLoad,
      hookAfterWindowResize,
      respond,
      bindEvents,
    };
  })();

  const sh = (function() {
    function splitVariantCode(code, asObject) {
      var parts = code.split("-"),
        res = asObject ? {} : [];
      for(var i = 0; i < parts.length; i += 2) {
        var pair = [
          common.parseNumber(parts[i]),
          common.parseNumber(parts[i + 1])
        ];
        if(asObject)
          res[pair[0]] = pair[1];
        else
          res.push(pair);
      }
      return res;
    }

    function joinVariantCode(pairs) {
      let tempVariantCode = [];
      if(Array.isArray(pairs)) {
        for(let p of pairs)
          tempVariantCode.push(String(p[0]) + "-" + String(p[1]))
      } else {
        for(let key in pairs)
          tempVariantCode.push(String(key) + "-" + String(pairs[key]));
      }
      tempVariantCode.sort();
      return tempVariantCode.join("-");
    }

    function extractVariantCode($el) {
      var className;
      if($el instanceof $)
        className = $el.attr("class") || "";
      else
        className = $el;
      for(let c of className.split(" ")) {
        let m = c.trim().match(/^([0-9-]+)$/);
        if(m)
          return m[1];
      }
      return null;
    }

    function getNecessaryVariantData(necessaryVariantData, asObject = false) {
      if(necessaryVariantData instanceof $) {
        const script = necessaryVariantData.find(".detail-parameters,.p-variants-block").find("script").html();
        const dataSerialized = script?.match(/shoptet.variantsSplit.necessaryVariantData = (.+);/)?.[1];
        necessaryVariantData = dataSerialized ? JSON.parse(dataSerialized) : {};
      } else if(!common.isPlainObject(necessaryVariantData)) {
        asObject = asObject || Boolean(necessaryVariantData);
        necessaryVariantData = null;
      }

      const variants = necessaryVariantData || shoptet.variantsSplit.necessaryVariantData || {};
      for(let code in variants) {
        const variant = variants[code];
        if(variant.tb_code)
          continue;

        variant.tb_code = code;
        variant.tb_parameterValues = splitVariantCode(code, false);
        variant.tb_parameterValuesObj = splitVariantCode(code, true);
        variant.tb_price = common.parsePrice(variant.price);
        variant.tb_standardPrice = common.parsePrice(variant.standardPrice);
      }
      return asObject ? variants : Object.values(variants);
    }

    function getSelectedParameterValues($form, inclMissing = false) {
      if(!$form)
        $form = $(".p-detail");

      const parameterValues = {};
      $form.find('.variant-list .hidden-split-parameter, .variant-list .split-parameter').each(function() {
        const parameterId = $(this).data("parameterId");
        const valueId = $(this).find('input:checked,option:selected').val();
        if(valueId !== '')
          parameterValues[parameterId] = tb.common.parseNumber(valueId);
        else if(inclMissing)
          parameterValues[parameterId] = null;
      });
      return parameterValues;
    }

    function convertImageUrl(url, size = "orig") {
      if(!["detail", "thumb", "related", "big", "orig"].includes(size))
        throw new Error("Invalid image size: " + size);
      return url.replace(/\/(detail|thumb|related|orig|big)\//, "/" + size + "/");
    }

    function getDescriptiveParameters($detail, asObject = false) {
      if(!$detail)
        $detail = $(".p-detail");
      const params = [];
      dom.$each($detail.find(".extended-description .detail-parameters tr"), $tr => {
        const name = dom.getTextShallow($tr.find(".row-header-label")).trim();
        if(name)
          params[name] = { $tr, name, value: $tr.find("td").text().trim(), };
      });
      return asObject ? params : Object.values(params);
    }

    return {
      splitVariantCode, joinVariantCode, extractVariantCode,
      getNecessaryVariantData, getSelectedParameterValues, getDescriptiveParameters,
      convertImageUrl,
    };
  })();

  const ui = (function() {
    function loadAndOpenModal(url, selector, size) {
      size = size || "lg";
      size = size.slice(0, 1).toUpperCase() + size.slice(1).toLowerCase();

      return ajax.loadDocument(url).then(function($page) {
        const $content = typeof selector === "function" ? $(selector($page)) : $page.find(selector);
        if(!$content.length)
          throw new Error("Element not found: " + selector);

        return new Promise(function(resolve) {
          shoptet.modal.open({
            html: $(shoptet.content.colorboxHeader + shoptet.content.colorboxFooter).html($content),
            width: shoptet.modal.config["width" + size],
            className: shoptet.modal.config["class" + size],
            onComplete: function() {
              $(".colorbox-html-content img").unveil();
              $("body").removeClass(shoptet.config.bodyClasses);
              if($(".overlay").length > 0) {
                $(".overlay").detach()
              }
              setTimeout((function() {
                shoptet.modal.shoptetResize()
              }
              ), 1);
              resolve();
            }
          });
        });
      });
    }

    function responsiveSlick(breakpoint, $el, options) {
      $el = $($el).filter(function() {
        return dom.oneTime(this, "responsiveSlick");
      });
      if(typeof breakpoint !== "function") {
        let maxWidth = breakpoint;
        breakpoint = function(width) {
          return width <= maxWidth;
        };
      }

      var oldVisible = null;
      function resizeHandler() {
        var visible = !!breakpoint($(window).width());
        if(visible === oldVisible)
          return;
        $el = $el.filter(function() {
          return this.isConnected;
        });
        if(!$el.length) {
          $(window).off("resize", resizeHandler);
          return;
        }
        try {
          if(visible)
            $el.slick(options);
          else if(oldVisible)
            $el.slick("destroy");
        } finally {
          oldVisible = visible;
        }
      }
      $(window).resize(common.debounce(resizeHandler, 250));
      resizeHandler();
    }

    const tabletSlick = responsiveSlick.bind(null, config.tabletSlickBreakpoint);
    const mobileSlick = responsiveSlick.bind(null, config.mobileSlickBreakpoint);

    return {
      loadAndOpenModal,
      responsiveSlick,
      tabletSlick, mobileSlick,
    };
  })();

  class JsonStorage {
    constructor(key, defaultFactory = (() => ({})), backend = window.sessionStorage) {
      if(!common.isString(key))
        throw new Error("Storage key must be a string.");
      this.key = key;
      this.defaultFactory = defaultFactory;
      this.backend = backend;
    }

    static local(key, defaultFactory = (() => ({}))) {
      return new JsonStorage(key, defaultFactory, window.localStorage);
    }

    static session(key, defaultFactory = (() => ({}))) {
      return new JsonStorage(key, defaultFactory, window.sessionStorage);
    }

    get() {
      const rawValue = this.backend.getItem(this.key);
      return rawValue === null ? this.defaultFactory() : JSON.parse(rawValue);
    }

    set(obj) {
      this.backend.setItem(this.key, JSON.stringify(obj));
    }

    clear() {
      this.backend.removeItem(this.key);
    }

    updateAndGet(f) {
      const obj = f(this.get());
      this.set(obj);
      return obj;
    }

    /** @deprecated */
    getAndUpdate(f) {
      return this.updateAndGet(f);
    }
  }

  const toolbox = {
    config,
    common,
    helpers,
    dom, $h, $t,
    ajax,
    hooks,
    sh,
    ui,
    JsonStorage,
  };

  if(window.toolbox)
    console.error("toolbox is already loaded, original:", window.toolbox);

  window.toolbox = window.tb = toolbox;
  return toolbox;

})();
"use strict";
(function (tb) {

  // Modules v2

  if (!tb)
    throw new Error("toolbox is not loaded");

// === AdvancedOrderHooks.js ===
const AdvancedOrderHooks = (function() {
  const filters = [];
  function addContentFilter(callback) {
    filters.push(callback);
  }

  function isPromise(obj) {
    return obj && obj.then;
  }

  function transformAdvancedOrderContent(content, $lastForm) {
    return filters.reduce(function(contentOrPromise, filter) {
      if(isPromise(contentOrPromise))
        return Promise.resolve(contentOrPromise).then(content => filter(content, $lastForm));
      return filter(contentOrPromise, $lastForm);
    }, content);
  }

  let $lastForm = $();
  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      tb.hooks.hookFn("shoptet.tracking.handleAction", function(handleAction, args, context) {
        $lastForm = $(args[0]);
        return handleAction.apply(context, args);
      });

      tb.hooks.hookFn("shoptet.ajax.makeAjaxRequest", function(makeAjaxRequest, args, context) {
        const url = args[0], callbacks = args[3];
        if(typeof url === "string" && url.startsWith(shoptet.config.advancedOrderUrl))
          callbacks.success = tb.hooks.hookFn(callbacks.success, function(success, args, context) {
            const response = args[0];
            const payload = response.getPayload();
            if(!payload.content)
              return success.apply(context, args);

            let contentOrPromise = transformAdvancedOrderContent(payload.content, $lastForm);
            if(isPromise(contentOrPromise))
              return Promise.resolve(contentOrPromise).then(function(content) {
                payload.content = content;
                success.apply(context, args);
              });

            payload.content = contentOrPromise;
            return success.apply(context, args);
          });
        return makeAjaxRequest.apply(context, args);
      });
    }
  });

  return { init, addContentFilter };
})();

// === AjaxSubmitFormHooks.js ===
const AjaxSubmitFormHooks = (function() {
  let ajaxSubmitFormArgs;
  const callbackTransformers = [];
  function ajaxSubmitForm(action, form, callingFunctions, replaceContent, displaySpinner, _transformCallbacks) {
    if(_transformCallbacks)
      callbackTransformers.push(_transformCallbacks);
    shoptet.cart.ajaxSubmitForm(action, form, callingFunctions, replaceContent, displaySpinner);
    if(_transformCallbacks)
      callbackTransformers.splice(callbackTransformers.indexOf(_transformCallbacks), 1);
  }

  function ajaxSubmitFormAsync(action, form, callingFunctions, replaceContent, displaySpinner) {
    return new Promise((resolve, reject) => {
      AjaxSubmitFormHooks.ajaxSubmitForm(action, form, callingFunctions, replaceContent, displaySpinner, (callbacks) => {
        callbacks.success = tb.hooks.hookFn(callbacks.success, (success, args, context) => {
          const res = success.apply(context, args);
          resolve(args[0]);
          return res;
        });
        callbacks.failed = tb.hooks.hookFn(callbacks.failed, (failed, args, context) => {
          const res = failed.apply(context, args);
          reject(args[0]);
          return res;
        });
      });
    });
  }

  function hookAjaxSubmitFormCallbacks(transformCallbacks) {
    callbackTransformers.push((callbacks, args) => args && transformCallbacks(callbacks, args));
  }

  function hookAjaxSubmitFormSuccess(callback) {
    hookAjaxSubmitFormCallbacks((callbacks, ajaxSubmitFormArgs) => {
      callbacks.success = tb.hooks.hookFn(callbacks.success, (success, args, context) => {
        callback(() => success.apply(context, args), args[0], ajaxSubmitFormArgs);
      });
    });
  }

  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      tb.hooks.hookFn("shoptet.cart.ajaxSubmitForm", function(ajaxSubmitForm, args, context) {
        ajaxSubmitFormArgs = args;
        ajaxSubmitForm.apply(context, args);
        ajaxSubmitFormArgs = null;
      });
      tb.hooks.hookFn("shoptet.ajax.makeAjaxRequest", function(makeAjaxRequest, args, context) {
        var callbacks = args[3];
        for(let transformCallbacks of callbackTransformers)
          transformCallbacks(callbacks, ajaxSubmitFormArgs);
        return makeAjaxRequest.apply(context, args);
      });
    }
  });

  return { init, ajaxSubmitForm, ajaxSubmitFormAsync, hookAjaxSubmitFormCallbacks, hookAjaxSubmitFormSuccess };
})();

// === CarrierRemark.js ===
/** Add carrier remark textarea under standard remark. */
const CarrierRemark = (function($h, $t) {
  const config = {
    maxLength: 50,
    rows: 4,

    fallbackLang: "cs",
    trans: {
      cs: {
        remarkPlaceholder: "Vaše poznámka pro dopravce",
        remarkCheckboxLabel: "Zadat poznámku pro dopravce",
      },
      sk: {
        remarkPlaceholder: "Vaša poznámka pre dopravcov",
        remarkCheckboxLabel: "Zadať poznámku pre dopravcov",
      },
      de: {
        remarkPlaceholder: "Ihr Hinweis an die Beförderer",
        remarkCheckboxLabel: "Hinweise zur Lieferung",
      }
    },
  };

  function bindTextarea($ta) {
    $("#order-form").on("ShoptetSuccessfulValidation", function(e) {
      var $remark = $("#remark"),
        remark = $remark.val().trim(),
        carrierRemark = $ta.val().trim();

      var parts = [];
      if(remark !== "")
        parts.push("# Poznámka\n" + remark);
      if(carrierRemark !== "")
        parts.push("# Poznámka pro dopravce\n" + carrierRemark);

      $remark.val(parts.join("\n\n"));
    });
  }

  function createRemarkElements() {
    var $ta = $h("textarea#carrier-remark.form-control", {
      placeholder: t.remarkPlaceholder,
      maxlength: String(config.maxLength),
      rows: String(config.rows),
    });
    bindTextarea($ta);
    return [
      $h(".form-group", [
        $h("input#add-carrier-note", {
          type: "checkbox",
          "data-unveil": "carrier-note"
        }),
        $h("label.whole-width", {
          "for": "add-carrier-note"
        }, t.remarkCheckboxLabel)
      ]),
      $h("div#carrier-note.js-hidden", [
        $h("fieldset.box.box-sm.box-bg-default", [
          $ta
        ])
      ])
    ];
  }

  let t;
  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      t = tb.helpers.getStrings(config);

      if(getShoptetDataLayer("pageType") !== "customerDetails")
        return false;
    },
    earlyRender() {
      tb.dom.$eachOneTime("#note", $note => {
        $note.after(createRemarkElements());
      }, "CarrierRemark");
    },
  });

  return { config, init };
})(tb.$h, tb.$t);

// === CartItemData.js ===
const CartItemData = (function($h) {
  const config = {
    storageKey: "cartItemData",
    compareCallback: function(a, b) {
      return a === b;
    },
    cloneCallback: function(item) {
      return JSON.parse(JSON.stringify(item));
    },
    fallbackLang: "cs",
    trans: {
      cs: {
        quantityLocked: "Množství nelze měnit, protože k položce jsou připojena dodatečná data"
      },
      sk: {
        quantityLocked: "Množstvo nie je možné meniť, pretože k položke sú pripojené dodatočné dáta",
      },
      en: {
        quantityLocked: "The quantity cannot be changed because the item has additional data attached",
      },
    },
  };

  var addToCartSuccessCallback;

  function isCartEmpty() {
    var cart = getShoptetDataLayer("cart");
    return cart && !cart.length;
  }

  function getStoredItems() {
    return JSON.parse(localStorage.getItem(config.storageKey) || "[]");
  }

  function setStoredItems(items) {
    localStorage.setItem(config.storageKey, JSON.stringify(items));
  }

  function generateUid() {
    return Date.now().toString(36) + Math.random().toString(36).slice(2);
  }

  function saveCustomProductData(productData, amount, customData) {
    var item = {
      uid: generateUid(),
      productData: productData,
      amount: amount,
      customData: customData
    };

    var items = getStoredItems();
    items.push(item);
    setStoredItems(items);

    return item;
  }

  function cleanupStoredItems() {
    if(isCartEmpty())
      localStorage.removeItem(config.storageKey);

    var items = getStoredItems(), dirty = false;
    for(let item of items)
      if(!item.uid) {
        item.uid = generateUid();
        dirty = true;
      }
    if(dirty)
      setStoredItems(items);
  }

  function extractCurrentAmount($el) {
    return tb.common.parseNumber($el.find("input[name=amount]").val());
  }

  function extractProductDataFromDetail($detail) {
    var formData = $detail.find("#product-detail-form").serializeArray(),
      formDataObj = tb.common.indexBy(formData, tb.common.property("name"));

    var productId = tb.common.parseNumber(formDataObj.productId.value),
      priceId = tb.common.parseNumber(formDataObj.priceId.value),
      identifier = $detail.find("meta[itemprop=identifier]").attr("content"),
      sku = $detail.find(".p-code > span:not(:first-child):not(.noDisplay)").text().trim() || undefined,
      surcharges = {}, surchargesArr = [];

    $detail.find("select.surcharge-parameter").each(function() {
      var parameterName = $(this).data("parameterName");

      var $selected = $(this).find(":selected");
      if($selected.val() === "")
        surcharges[parameterName] = "";
      else {
        const selectedText = $selected.text().split(/ \+(?:[0-9,.]+.+|.+?[0-9,.]+)$/)[0];
        surcharges[parameterName] = selectedText;
        surchargesArr.push(parameterName + " - " + selectedText);
      }
    });

    return { productId, priceId, identifier, sku, surcharges, surchargesArr };
  }

  function extractProductDataFromCartWidgetRow($row) {
    var identifier = $row.data("microIdentifier"),
      sku = $row.attr("data-micro-sku"),
      priceId = tb.common.parseNumber($row.find("input[name=priceId]").val());

    return { priceId, identifier, sku };
  }

  function _extractSurchargesHelper($row) {
    const $surcharges = $row.find(".main-link-surcharges");
    if(!$surcharges.length)
      return {};

    const surcharges = {};
    const pairs = $surcharges.text().trim().replace(/^[^:]+: /, "").split(/, (?=[\p{Lu}\p{N}])/u);
    for(let p of pairs) {
      const pair = p.split(/ - (?=[\p{Lu}\p{N}])/u);
      surcharges[pair[0]] = pair[1];
    }
    return surcharges;
  }

  function _extractSurchargesArrHelper($row) {
    const $surcharges = $row.find(".main-link-surcharges");
    if(!$surcharges.length)
      return [];

    return $surcharges.text().trim().replace(/^[^:]+: /, "").split(/, (?=[\p{Lu}\p{N}])/u);
  }

  function extractProductDataFromCartTableRow($row) {
    var identifier = $row.data("microIdentifier"),
      sku = $row.attr("data-micro-sku"),
      priceId = tb.common.parseNumber($row.find("input[name=priceId]").val()),
      surcharges = _extractSurchargesHelper($row),
      surchargesArr = _extractSurchargesArrHelper($row);

    return { priceId, identifier, sku, surcharges, surchargesArr };
  }

  function extractProductDataFromOrderSummaryRow($row) {
    var identifier = $row.data("microIdentifier"),
      sku = $row.attr("data-micro-sku"),
      surcharges = _extractSurchargesHelper($row),
      surchargesArr = _extractSurchargesArrHelper($row);

    return { identifier, sku, surcharges, surchargesArr };
  }

  function addProductToCart(payload, customData) {
    // TODO
  }

  function addTriggerInputToForm($form) {
    return $h("input", { type: "hidden", name: "__hasCustomData", value: "1" })
      .appendTo($form);
  }

  function setupDetailCustomData($detail, customData) {
    var $form = $detail.find("#product-detail-form"),
      $triggerInput = addTriggerInputToForm($form),
      productData = extractProductDataFromDetail($detail),
      amount = extractCurrentAmount($form);

    addToCartSuccessCallback = function(response) {
      saveCustomProductData(productData, amount, customData);
    };
    setTimeout(function() {
      $triggerInput.remove();
      addToCartSuccessCallback = null;
    }, 50);
  }

  function addDetailProductToCart($detail, customData) {
    var $form = $detail.find("#product-detail-form");

    setupDetailCustomData($detail, customData);
    $form.trigger("submit");
  }

  function itemProductDataMatcher(productData) {
    function compareValues(key, a, b, useSurchargesArr) {
      if(key === "surcharges") {
        if(useSurchargesArr)
          return true;
        for(let k in a) {
          if(a[k] !== b[k] && !(a[k] === "" && b[k] === undefined))
            return false;
        }
        for(let k in b) {
          if(b[k] !== a[k] && !(b[k] === "" && a[k] === undefined))
            return false;
        }
        return true;
      } else if(key === "surchargesArr") {
        if(!useSurchargesArr)
          return false;
        return a.length === b.length && a.every(v => b.includes(v));
      } else {
        return a === b;
      }
    }

    return function(item) {
      const useSurchargesArr = item.productData.surchargesArr && productData.surchargesArr;

      for(let key in item.productData) {
        if(productData[key] !== undefined && !compareValues(key, productData[key], item.productData[key], useSurchargesArr))
          return false;
      }
      for(let key in productData) {
        if(item.productData[key] !== undefined && !compareValues(key, productData[key], item.productData[key], useSurchargesArr))
          return false;
      }
      return true;
    };
  }

  function getMatchingCustomItemsForProduct(productData) {
    var items = getStoredItems();
    return items.filter(itemProductDataMatcher(productData));
  }

  function lockCartRowQuantity($row) {
    if(!t)
      t = tb.helpers.getStrings(config);

    const $quantity = $($row).find(".quantity");
    $quantity.addClass("readonly");
    $quantity.find(".increase, .decrease").addClass("hidden");
    $quantity.find("input").prop("readonly", true);
    $quantity.attr("title", t.quantityLocked);
  }

  function restrictCartWidget() {
    var $cartWidget = $(".cart-widget");
    if(!$cartWidget.length)
      return;

    $cartWidget.find(".cart-widget-product").each(function() {
      var $row = $(this),
        info = extractProductDataFromCartWidgetRow($row);

      if(getMatchingCustomItemsForProduct(info).length)
        lockCartRowQuantity($row);
    });
  }

  function cloneCustomItem(item) {
    return {
      uid: null,
      originalItem: item.originalItem || item,

      productData: item.productData,
      amount: item.amount,
      customData: config.cloneCallback(item.customData),
    };
  }

  function linkCustomItemsToRows(rows) {
    var remainingItems = getStoredItems().slice();

    for(let row of rows) {
      let matcher = itemProductDataMatcher(row.productData),
        matchingItems = [],
        amount = row.amount;
      for(let i = remainingItems.length; amount > 0 && i-- > 0;) { // match newest custom items first
        let item = remainingItems[i];
        if(!matcher(item))
          continue;
        if(item.amount <= amount) { // eat whole item
          matchingItems.push(item);
          amount -= item.amount;
          remainingItems.splice(i, 1);
        } else {
          let clone = cloneCustomItem(item);
          clone.amount = amount;
          matchingItems.push(clone);
          item.amount -= amount;
          amount = 0;
        }
      }

      row.matchingItems = matchingItems;
      row.amountLeft = amount;

      if(row.$el) {
        row.$el.data("productData", row.productData);
        row.$el.data("amount", row.amount);
        row.$el.data("matchingItems", row.matchingItems);
        row.$el.data("amountLeft", row.amountLeft);
      }
    }

    if(remainingItems.length)
      console.warn("Remaining items:", remainingItems);

    return rows;
  }

  function linkCartTableRows($rows) {
    var rows = $rows.map(function() {
      var $t = $(this);

      return {
        $el: $t,
        productData: extractProductDataFromCartTableRow($t),
        amount: extractCurrentAmount($t)
      };
    }).toArray();
    return linkCustomItemsToRows(rows);
  }

  function linkOrderSummaryRows($rows) {
    var rows = $rows.map(function() {
      var $t = $(this);

      return {
        $el: $t,
        productData: extractProductDataFromOrderSummaryRow($t),
        amount: tb.common.parseNumber($t.find(".cart-item-amount").text())
      };
    }).toArray();
    return linkCustomItemsToRows(rows);
  }

  function appendCustomRows(rows, renderCallback) {
    for(let row of rows) {
      if(!row.matchingItems.length)
        continue;

      let $last = row.$el;
      for(let item of row.matchingItems) {
        let $r = renderCallback(item, row.$el, row);
        if(!$r || !$($r).length)
          continue;
        $last = $($r)
          .data("matchingItem", item)
          .data("row", row)
          .insertAfter($last);
      }
    }
  }

  function reduceCartRowAmount($row, amount) {
    var currentAmount = extractCurrentAmount($row);

    var $updateForm;
    if(currentAmount > amount) {
      var $input = $row.find("input[name=amount]");
      $input.val(currentAmount - amount);
      $updateForm = $input.closest("form");
    } else {
      $updateForm = $row.find(".remove-item").closest("form");
    }

    shoptet.cart.ajaxSubmitForm($updateForm.attr("action"), $updateForm[0], "functionsForCart", "cart", true);
  }

  function removeCustomItem(item, row, removeFromCart) {
    var uid = item.originalItem ? item.originalItem.uid : item.uid;

    if(removeFromCart && row.$el)
      reduceCartRowAmount(row.$el, item.amount);

    var items = getStoredItems(),
      index = tb.common.findIndex(items, function(item) {
        return item.uid === uid;
      });

    if(index === -1)
      return false;

    items[index].amount -= item.amount;
    if(items[index].amount <= 0)
      items.splice(index, 1);

    setStoredItems(items);
  }

  let t;
  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      t = tb.helpers.getStrings(config);

      // check for empty cart after every update
      tb.hooks.hookFn("shoptet.tracking.handleAction", function(handleAction, args, context) {
        const form = args[0], response = args[1];
        handleAction.apply(context, args);

        if(shoptet.tracking.getFormAction(form.getAttribute("action")) && response.getFromPayload("cartItems") && !response.getFromPayload("cartItems").length)
          cleanupStoredItems(); // workaround bug in shoptet - getShoptetDataLayer("cart") is sometimes cleared after error
      });
      cleanupStoredItems();

      tb.hooks.hookFn("shoptet.ajax.makeAjaxRequest", function(makeAjaxRequest, args, context) {
        var data = args[2], callbacks = args[3];
        if(typeof data === "string" && data.indexOf("__hasCustomData") !== -1) {
          var _addToCartSuccessCallback = addToCartSuccessCallback;
          addToCartSuccessCallback = null;

          callbacks.success = tb.hooks.hookFn(callbacks.success, function(success, args, context) {
            var response = args[0];
            if(_addToCartSuccessCallback)
              _addToCartSuccessCallback(response);

            return success.apply(context, args);
          });
        }

        return makeAjaxRequest.apply(context, args);
      });
    },
    earlyRender() {
      restrictCartWidget();
    }
  });

  return {
    init,
    extractProductDataFromDetail,
    extractProductDataFromCartTableRow,
    extractProductDataFromCartWidgetRow,
    extractProductDataFromOrderSummaryRow,
    extractCurrentAmount,
    addProductToCart,
    addDetailProductToCart,
    setupDetailCustomData,
    linkCustomItemsToRows,
    linkCartTableRows,
    linkOrderSummaryRows,
    appendCustomRows,
    removeCustomItem,
    lockCartRowQuantity,
    getStoredItems
  };

})(tb.$h);

// === DelayedCart.js ===
/** Delay cart widget from showing on hover by a specified timeout. */
const DelayedCart = (function() {
  const config = {
    timeout: 500
  };

  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      var showCartTimeout = null;
      function reset() {
        clearTimeout(showCartTimeout);
        showCartTimeout = null;
      }

      tb.hooks.hookFn("shoptet.global.showPopupWindow", function(showPopupWindow, args, context) {
        var target = args[0], show = args[1];
        if(target === "cart" && show) {
          if(showCartTimeout)
            return;
          showCartTimeout = setTimeout(function() {
            reset();
            showPopupWindow.apply(context, args);
          }, config.timeout);
          return;
        }

        if(!show)
          reset();
        return showPopupWindow.apply(context, args);
      });

      $(function() {
        $("html").on("mouseleave", '.toggle-window[data-hover="true"]', reset);
      });
    }
  });

  return { config, init };
})();

// === DetailHooks.js ===
const DetailHooks = (function() {
  let detailLoaded = false;

  function hookAfterVariantChange(callback) {
    document.addEventListener("TVariantChanged", callback);
    if(detailLoaded)
      callback();
  }

  function hookAfterQuantityChange(callback) {
    document.addEventListener("TQuantityChanged", callback);
    if(detailLoaded)
      callback();
  }

  function signalVariantChange() {
    shoptet.scripts.signal("TVariantChanged", null, null, null);
  }

  function signalQuantityChange() {
    shoptet.scripts.signal("TQuantityChanged", null, null, null);
  }

  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      // surcharges, variantsSplit
      tb.hooks.hookFn("shoptet.surcharges.updatePrices", function(updatePrices, args, context) {
        updatePrices.apply(context, args);
        signalVariantChange();
      });

      // variants simple, reset link
      for(let ev of ["ShoptetVariantUnavailable", "ShoptetVariantAvailable"])
        document.addEventListener(ev, signalVariantChange);

      let resetTimeout;
      document.addEventListener("ShoptetSelectedParametersReset", e => {
        clearTimeout(resetTimeout);
        resetTimeout = setTimeout(signalVariantChange, 0);
      });

      // quantity + and - buttons
      tb.hooks.hookFn("shoptet.helpers.updateQuantity", (updateQuantity, args, context) => {
        const el = args[0];
        // class for compat with InlineProductDetail
        if($(el).closest("#product-detail-form,.product-detail-form").length) {
          args[5] = tb.hooks.hookFn(args[5] || (() => {}), (origCallback, args, context) => {
            signalQuantityChange();
            return origCallback.apply(context, args);
          });
        }
        return updateQuantity.apply(context, args);
      });

      // quantity input events
      $("body").on("change input", "input[name=amount]", function(e) {
        if($(this).closest("#product-detail-form,.product-detail-form").length) {
          signalQuantityChange();
        }
      });

      // page load
      if($("body.type-detail").length) {
        signalVariantChange();
        signalQuantityChange();
        detailLoaded = true;
      }
    }
  });

  return { init, signalVariantChange, hookAfterVariantChange, signalQuantityChange, hookAfterQuantityChange };
})(); 

// === ExternalRenderEvents.js ===
/** Signal DOM load after external addons add their elements. */
const ExternalRenderEvents = (function() {
  const config = {
    navstiveneProdukty: false,
    shoptetModal: false,
    luigisBox: false,
    premiumCarousel: false,
    countdown: false,
    sideCart: false,
    shippingDate: false,
    upsell: false,
    mehubBonusCart: false,
    satisflowReview: false,
    dkLabComparer: false,
    tuito: false,
    quickView: false,
  };

  function signalDomLoadAfter(name) {
    if(!tb.common.getProperty(window, name))
      return;
    tb.hooks.hookFn(name, function(origFn, args, context) {
      origFn.apply(context, args);
      tb.hooks.signalDomLoad();
    });
  }

  const hooks = {
    navstiveneProdukty() {
      signalDomLoadAfter("window.showVisitedProducts");
    },
    shoptetModal() {
      tb.hooks.hookFn("shoptet.modal.open", function(open, args, context) {
        var options = args[0];
        if(!options)
          options = {};
        if(!options.onComplete)
          options.onComplete = function() {};

        options.onComplete = tb.hooks.hookFn(options.onComplete, function(onComplete, args, context) {
          onComplete.apply(context, args);
          tb.hooks.signalDomLoad();
        });

        open.call(context, options);
      });
    },
    luigisBox() {
      $("html").on("init", ".slick-slider", function() {
        if($(this).find(".lb-product").length)
          tb.hooks.signalDomLoad();
      });
    },
    premiumCarousel() {
      tb.hooks.hookFn("$.fn.mouseenter", function(mouseenter, args, context) {
        mouseenter.apply(context, args);
        if(context.is(".carousel-navigation"))
          tb.hooks.signalDomLoad();
        return context;
      });
    },
    countdown() {
      signalDomLoadAfter("window.compareGuids");
      signalDomLoadAfter("window.compareGuid");
    },
    sideCart() {
      signalDomLoadAfter("window.pkSuccessCallback");
    },
    shippingDate() {
      signalDomLoadAfter("window.fvstudio_shippingdate.checkTimepickerAvailability");
    },
    upsell() {
      function hookObject(obj) {
        if(!obj || !obj.runActually)
          return;
        let m = obj.runActually.toString().match(/API_URL = '(.+?)'/);
        if(!m)
          return;
        let API_URL = JSON.parse('"' + m[1] + '"');
        tb.hooks.hookFn("$.ajax", function(ajax, args, context) {
          let options = args[0];
          if(options.url === API_URL + "/data")
            options.success = tb.hooks.hookFn(options.success, function(success, args, context) {
              success.apply(context, args);
              tb.hooks.signalDomLoad();
            });
          return ajax.apply(context, args);
        });
      }
      hookObject(window.fvstudio);
      hookObject(window.fvstudio_dev);

      signalDomLoadAfter("window.fvStudioAppCartUpsell.onloaded");
    },
    mehubBonusCart() {
      if(!$(".in-kosik").length)
        return;
      // TODO: observer
      setInterval(function() {
        if(tb.dom.oneTime(".mehub-bonus-cart-container"))
          tb.hooks.signalDomLoad();
      }, 500);
    },
    satisflowReview() {
      signalDomLoadAfter("window.satisflowReviewInitModalReviewImage");
    },
    dkLabComparer() {
      signalDomLoadAfter("window.dkLabProductComparer.showNumberOfComparedItems");
    },
    tuito() {
      const $infoWrapper = $(".p-detail .p-info-wrapper");
      if(!$infoWrapper.length)
        return;
      const obs = new MutationObserver(mutationList => {
        for(let rec of mutationList) {
          if($(rec.addedNodes).filter(".tuito-data-table").length)
            tb.hooks.signalDomLoad();
        }
      });
      obs.observe($infoWrapper[0], { subtree: true, childList: true });
    },
    quickView() {
      const obs = new MutationObserver(mutationList => {
        if(tb.dom.oneTime(".quick-box-content .p-detail", "ExternalRenderEvents"))
          tb.hooks.signalDomLoad();
      });
      obs.observe(document.body, { subtree: true, childList: true });
    },
  };

  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      for(let hookName in hooks) {
        if(hooks.hasOwnProperty(hookName) && config[hookName])
          hooks[hookName]();
      }
    }
  });

  return { config, init };
})();

// === FavouriteProducts.js ===
/** Add favourite toggle to product blocks and detail, display favourite products on a custom page. */
const FavouriteProducts = (function($h) {
  const config = {
    storageKey: "favouriteProducts",
    productBlockSelector: ".product .p",
    callbackPreset: "clean",
    addBtnToDetailCallback: null,
    addBtnToProductBlockCallback: null,
    maxPriceLifetime: -1,

    wrapperClass: "",
    listClass: "products products-block products-favourite",
    itemClass: "product",
    renderOptions: {
      alwaysShowDetailBtn: true,
      showAvailability: false,
    },

    fallbackLang: "cs",
    trans: {
      cs: {
        favouritePageSelector: "body.in-oblibene",
        blockHeadingOuterHtml: tb.$h("h4", "Oblíbené produkty"),
        emptyNoticeHtml: "Váš seznam je bohužel prázdný.",
        copyLinkBtnHtml: "Kopírovat odkaz",
        copyLinkBtnCopiedHtml: "Zkopírováno",
        copyLinkLabelHtml: "Odkaz pro sdílení",
        addBtnHtml: "Přidat do oblíbených",
        removeBtnHtml: "Smazat z oblíbených",
      },
      sk: {
        favouritePageSelector: "body.in-oblibene,body.in-oblubene",
        blockHeadingOuterHtml: tb.$h("h4", "Obľúbené produkty"),
        emptyNoticeHtml: "Váš zoznam je bohužiaľ prázdny.",
        copyLinkBtnHtml: "Kopírovať odkaz",
        copyLinkBtnCopiedHtml: "Skopírované",
        copyLinkLabelHtml: "Odkaz na zdieľanie",
        addBtnHtml: "Pridať do obľúbených",
        removeBtnHtml: "Zmazať z obľúbených",
      },
      en: {
        favouritePageSelector: "body.in-oblibene,body.in-favourites",
        blockHeadingOuterHtml: tb.$h("h4", "Favourite Products"),
        emptyNoticeHtml: "Your list is unfortunately empty.",
        copyLinkBtnHtml: "Copy Link",
        copyLinkBtnCopiedHtml: "Copied",
        copyLinkLabelHtml: "Shareable Link",
        addBtnHtml: "Add to Favorites",
        removeBtnHtml: "Remove from Favorites"
      },
      de: {
        favouritePageSelector: "body.in-oblibene,body.in-favoriten",
        blockHeadingOuterHtml: tb.$h("h4", "Bevorzugte Produkte"),
        emptyNoticeHtml: "Leider ist Ihre Liste leer.",
        copyLinkBtnHtml: "Link kopieren",
        copyLinkBtnCopiedHtml: "Kopiert",
        copyLinkLabelHtml: "Link zum Teilen",
        addBtnHtml: "Zu den Favoriten hinzufügen",
        removeBtnHtml: "Aus den Favoriten löschen",
      },
    }
  };

  const callbackPresets = {
    compat: {
      addBtnToDetailCallback($detail, active) {
        var $div = $detail.find(".dkLabFavDiv").first();
        if(!$div.length) {
          $div = tb.$h(".dkLabFavDiv.dklabFavStyl2");
          if($detail.find(".product-top .add-to-cart, #choose-variant").length) {
            $detail.find(".product-top .add-to-cart, #choose-variant").after($div)
          } else {
            $detail.find(".p-info-wrapper .detail-parameters").after($div)
          }
        }

        if(active) {
          var $flags = $detail.find(".flags.flags-default").first();
          if(!$flags.length)
            $flags = $h(".flags.flags-default.flags-inline").prependTo($detail.find(".p-detail-info"));
          $flags.append($h("span.flag.flag-dklabFav", [$h("span.heart")]));

          $div.html('<span class="dkLabFavouriteControls dkFavSmazat" id="dkLabRemoveFavourite"><strong class="heart"></strong><span>' + t.removeBtnHtml + '</span></span>');
        } else {
          $detail.find(".flag-dklabFav").remove();
          $div.html('<span class="dkLabFavouriteControls dkFavPridat" id="dkLabAddFavourite"><strong class="heart"></strong><span>' + t.addBtnHtml + '</span></span>');
        }
        return $div.find(".dkLabFavouriteControls");
      },
      addBtnToProductBlockCallback($p, active) {
        var $inactiveBtn = $('<div class="dkLabFavouriteDiv dklabFavStyl2"><span class="dkLabFavouriteControls dkFavPridat"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="24" class="heart"><defs><symbol id="heart"><path d="M12 21.35l-1.45-1.32c-5.15-4.67-8.55-7.75-8.55-11.53 0-3.08 2.42-5.5 5.5-5.5 1.74 0 3.41.81 4.5 2.09 1.09-1.28 2.76-2.09 4.5-2.09 3.08 0 5.5 2.42 5.5 5.5 0 3.78-3.4 6.86-8.55 11.54l-1.45 1.31z"/></symbol></defs><use xlink:href="#heart" x="0" y="0" /></svg><strong class="heart"></strong><span>' + t.addBtnHtml + '</span></span></div>'),
          $activeBtn = $('<div class="dkLabFavouriteDiv dklabFavStyl2"><span class="dkLabFavouriteControls dkFavSmazat"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="24" class="heart"><defs><symbol id="heart"><path d="M12 21.35l-1.45-1.32c-5.15-4.67-8.55-7.75-8.55-11.53 0-3.08 2.42-5.5 5.5-5.5 1.74 0 3.41.81 4.5 2.09 1.09-1.28 2.76-2.09 4.5-2.09 3.08 0 5.5 2.42 5.5 5.5 0 3.78-3.4 6.86-8.55 11.54l-1.45 1.31z"/></symbol></defs><use xlink:href="#heart" x="0" y="0" /></svg><strong class="heart"></strong><span>' + t.removeBtnHtml + '</span></span></div>');

        if(active) {
          var $flags = $p.find(".flags.flags-default:first");
          if(!$flags.length)
            $flags = $h(".flags.flags-default").appendTo($p.find(".image"));
          $flags.append($h("span.flag.flag-dklabFav", [$h("span.heart")]));

          return $activeBtn.insertAfter($p.find(".name:first"));
        }

        $p.find(".flag-dklabFav").remove();
        return $inactiveBtn.insertAfter($p.find(".name:first"));
      }
    },
    clean: {
      addBtnToDetailCallback($detail, active) {
        var $div = $detail.find(".dkLabFavDiv").first();
        if(!$div.length) {
          $div = tb.$h(".dkLabFavDiv.dklabFavStyl2");
          if($detail.find(".product-top .add-to-cart, #choose-variant").length) {
            $detail.find(".product-top .add-to-cart, #choose-variant").after($div)
          } else {
            $detail.find(".p-info-wrapper .detail-parameters").after($div)
          }
        }

        if(active) {
          var $flags = $detail.find(".flags.flags-default").first();
          if(!$flags.length)
            $flags = $h(".flags.flags-default.flags-inline").prependTo($detail.find(".p-detail-info"));
          $flags.append($h("span.flag.flag-dklabFav", [$h("span.heart")]));

          $div.html('<span class="dkLabFavouriteControls dkFavSmazat" id="dkLabRemoveFavourite"><strong class="heart"></strong><span>' + t.removeBtnHtml + '</span></span>');
        } else {
          $detail.find(".flag-dklabFav").remove();
          $div.html('<span class="dkLabFavouriteControls dkFavPridat" id="dkLabAddFavourite"><strong class="heart"></strong><span>' + t.addBtnHtml + '</span></span>');
        }
        return $div.find(".dkLabFavouriteControls");
      },
      addBtnToProductBlockCallback: (() => {
        const $inactiveBtn = $('<div class="dkLabFavouriteDiv dklabFavStyl2"><span class="dkLabFavouriteControls dkFavPridat"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="24" class="heart"><defs><symbol id="heart"><path d="M12 21.35l-1.45-1.32c-5.15-4.67-8.55-7.75-8.55-11.53 0-3.08 2.42-5.5 5.5-5.5 1.74 0 3.41.81 4.5 2.09 1.09-1.28 2.76-2.09 4.5-2.09 3.08 0 5.5 2.42 5.5 5.5 0 3.78-3.4 6.86-8.55 11.54l-1.45 1.31z"/></symbol></defs><use xlink:href="#heart" x="0" y="0" /></svg></span></div>');
        const $activeBtn = $('<div class="dkLabFavouriteDiv dklabFavStyl2"><span class="dkLabFavouriteControls dkFavSmazat"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="24" class="heart"><defs><symbol id="heart"><path d="M12 21.35l-1.45-1.32c-5.15-4.67-8.55-7.75-8.55-11.53 0-3.08 2.42-5.5 5.5-5.5 1.74 0 3.41.81 4.5 2.09 1.09-1.28 2.76-2.09 4.5-2.09 3.08 0 5.5 2.42 5.5 5.5 0 3.78-3.4 6.86-8.55 11.54l-1.45 1.31z"/></symbol></defs><use xlink:href="#heart" x="0" y="0" /></svg></span></div>');
        const $favFlag = $h("span.flag.flag-dklabFav", [$h("span.heart")]);

        return ($p, active) => {
          if(active) {
            var $flags = $p.find(".flags.flags-default:first");
            if(!$flags.length)
              $flags = $h(".flags.flags-default").appendTo($p.find(".image"));

            $flags.append($favFlag.clone());
            return $activeBtn.clone().insertAfter($p.find(".name:first"));
          }

          $p.find(".flag-dklabFav").remove();
          return $inactiveBtn.clone().insertAfter($p.find(".name:first"));
        };
      })()
    }
  };

  let t;
  function getStrings() {
    const dl = getShoptetDataLayer();
    const lang = dl ? dl.language : config.fallbackLang;
    return config.trans[lang] || config.trans[config.fallbackLang] || {};
  }

  function getStringCompat(key) {
    return config[key] || t[key] || "";
  }

  function getProducts() {
    return JSON.parse(localStorage.getItem(config.storageKey) || "[]");
  }

  function setProducts(products) {
    localStorage.setItem(config.storageKey, JSON.stringify(products));
  }

  function isFavouriteProductFactory() {
    var products = getProducts(),
      productsByUrl = tb.common.indexBy(products, function(p) {
        return p.url;
      }),
      productsByIdentifier = tb.common.indexBy(products, function(p) {
        return p.identifier;
      }),
      productsById = tb.common.indexBy(products, function(p) {
        return p.productId;
      });

    return function isFavouriteProduct(info) {
      if(info.url && productsByUrl.hasOwnProperty(info.url))
        return true;
      if(info.identifier && productsByIdentifier.hasOwnProperty(info.identifier))
        return true;
      if(info.productId && productsById.hasOwnProperty(info.productId))
        return true;
      return false;
    };
  }

  function getProductBlockInfo($p) {
    return {
      productId: $p.data("microProductId"),
      identifier: $p.data("microIdentifier"),
      url: $p.find("[data-micro=url]").attr("href")
    };
  }

  function updateProductBlocks(force) {
    var $productBlocks = $(config.productBlockSelector);
    if(!$productBlocks.length)
      return false;

    var isFavouriteProduct = isFavouriteProductFactory(), changed = false;
    $productBlocks.each(function() {
      var $p = $(this);
      if(!tb.dom.oneTime($p, "FavouriteProducts") && !force)
        return;

      var info = getProductBlockInfo($p);
      if(force)
        $p.find(".favourite-products-toggle").remove();

      var callback = config.addBtnToProductBlockCallback || callbackPresets[config.callbackPreset].addBtnToProductBlockCallback;
      var $btn = callback($p, isFavouriteProduct(info));
      $btn.addClass("favourite-products-toggle");
      changed = true;
    });
    return changed;
  }

  let lastDetailUrl = null;
  function updateDetail(force) {
    var $detail = $(".p-detail");
    if(!$detail.length)
      return false;

    let info = ProductInfo.getDetailProductInfo($detail);
    info = transformProductInfo(info);
    if(lastDetailUrl !== null && lastDetailUrl !== info.url)
      force = true;
    lastDetailUrl = info.url;

    if(!tb.dom.oneTime($detail, "FavouriteProducts") && !force)
      return false;

    var isFavouriteProduct = isFavouriteProductFactory();
    if(force)
      $detail.find(".favourite-products-toggle.--detail").remove();
    var callback = config.addBtnToDetailCallback || callbackPresets[config.callbackPreset].addBtnToDetailCallback;
    var $btn = callback($detail, isFavouriteProduct(info));
    $btn.addClass("favourite-products-toggle --detail");
    return true;
  }

  function updateFavouriteBlocks() {
    var products = getProducts();
    var $blocks = $(".favourite-block:not(.--view-only)");
    $blocks.each(function() {
      var $newBlock = renderFavouriteBlockInner(products);
      $(this).replaceWith($newBlock);
      $newBlock.find("img").unveil();
    });
  }

  function updateFavouriteCount() {
    var products = getProducts();
    $(".favourite-count").text(products.length).toggleClass("--empty", !products.length);
  }

  function fetchProductInfo(url) {
    return tb.ajax.loadDocument(url).then(function($doc) {
      var $detail = $doc.find(".p-detail");
      return $detail.length && ProductInfo.getDetailProductInfo($detail);
    });
  }

  const tmpLink = document.createElement("a");
  function canonicalizeUrl(url) {
    tmpLink.href = url;
    let pathname = tmpLink.pathname;
    if(pathname.slice(-1) !== "/")
      pathname += "/";
    return pathname;
  }

  function transformProductInfo(info) {
    if(info && info.url)
      info.url = canonicalizeUrl(info.url);
    return info;
  }

  function toggleFavouriteProduct(info, isDetailInfo, newActive) {
    info = transformProductInfo(info);

    const products = getProducts();
    const activeIndex = tb.common.findIndex(products, function(p) {
      if(info.url && p.url === info.url)
        return true;
      if(info.identifier && p.identifier === info.identifier)
        return true;
      if(info.productId && p.productId === info.productId)
        return true;
      return false;
    });

    if(newActive === undefined)
      newActive = activeIndex === -1;

    if((activeIndex === -1 && !newActive) || (activeIndex !== -1 && newActive))
      return Promise.resolve(newActive);

    if(newActive && !isDetailInfo)
      return fetchProductInfo(info.url).then(function(newInfo) {
        return toggleFavouriteProduct(newInfo, true, newActive);
      });

    if(newActive)
      products.push(transformProductInfo(info));
    else
      products.splice(activeIndex, 1);
    setProducts(products);

    updateFavouriteBlocks();
    updateDetail(true);
    updateProductBlocks(true);
    updateFavouriteCount();
    tb.hooks.signalDomLoad();

    return Promise.resolve(newActive);
  }

  function renderProductBlock(info) {
    const renderOptions = Object.assign({}, config.renderOptions);
    if(!info.timestamp || Date.now() - info.timestamp > config.maxPriceLifetime) {
      renderOptions.showPrice = renderOptions.showAvailability = false;
    }

    return ProductInfo.renderProductBlock(info, renderOptions).data("favouriteProductInfo", info);
  }

  function getShareUrl(products) {
    var hash = "#" + btoa(products.map(function(info) {
      return canonicalizeUrl(info.url);
    }).join(","));

    var shareUrl = new URL(location.href);
    shareUrl.hash = hash;
    return shareUrl.toString();
  }

  function fetchProductsFromHash(hash) {
    hash = hash.slice(1);
    if(hash === "")
      return Promise.resolve([]);

    return Promise.resolve().then(function() {
      var urls = atob(hash).split(",").map(function(url) {
        return canonicalizeUrl(url);
      }).filter(function(url) {
        return !!url;
      });
      return Promise.all(urls.map(function(url) {
        return fetchProductInfo(url);
      }));
    }).then(function(products) {
      return products.filter(function(info) {
        return !!info;
      });
    });
  }

  const updatingProducts = {};
  function updateStaleProduct(url, $p) {
    if(updatingProducts[url]) {
      updatingProducts[url].push($p);
      return;
    }
    updatingProducts[url] = [$p];

    let products = getProducts();
    let info = tb.common.find(products, tb.common.matcher("url", url));
    if(!info ||
      (info.timestamp && Date.now() - info.timestamp <= config.maxPriceLifetime) ||
      (info.lastUpdateAttempt && Date.now() - info.lastUpdateAttempt <= config.maxPriceLifetime / 2)) {
      delete updatingProducts[url];
      return;
    }

    console.log("Updating", info.url);
    return fetchProductInfo(info.url).catch(function(err) {
      console.error(err);
      return null;
    }).then(function(newInfo) {
      let products = getProducts();
      let index = tb.common.findIndex(products, tb.common.matcher("url", url));
      if(index === -1) {
        delete updatingProducts[url];
        return;
      }
      if(!newInfo) {
        console.log("Update failed", info.url);
        products[index].lastUpdateAttempt = Date.now();
        setProducts(products);
      } else {
        products[index] = transformProductInfo(newInfo);
        setProducts(products);

        for(let $p of updatingProducts[url]) {
          if(!document.contains($p[0]))
            continue;
          let $newP = renderProductBlock(newInfo);
          $p.replaceWith($newP);
          $newP.find("img").unveil();
        }
        tb.hooks.signalDomLoad();
      }
      delete updatingProducts[url];
    });
  }

  function updateVisibleStaleProducts() {
    if(isViewingSharedFavourites || config.maxPriceLifetime <= 0)
      return;
    var scrollTop = $(window).scrollTop(),
      windowHeight = $(window).height();

    $(".favourite-block .p").each(function() {
      var $t = $(this);
      var offsetTop = $t.offset().top;
      if(offsetTop > scrollTop && offsetTop < scrollTop + windowHeight)
        updateStaleProduct($t.data("favouriteProductInfo").url, $t);
    });
  }

  function renderShareBtn(products) {
    var shareUrl = getShareUrl(products);

    return $h(".favourite-products-share", [
      $h("button.btn.btn-primary", { type: "button" }, [getStringCompat("copyLinkBtnHtml")]),
      $h(".favourite-products-share__tooltip", [
        $h("label", { for: "favouriteProductsShareUrl" }, [getStringCompat("copyLinkLabelHtml")]),
        $h("input", { id: "favouriteProductsShareUrl", readonly: true, value: shareUrl })
      ])
    ]);
  }

  function renderFavouriteBlockInner(products, renderConfig = {}) {
    renderConfig = Object.assign({}, config, renderConfig);

    products = products.map(function(info) {
      return $h("div", { class: renderConfig.itemClass }, [
        renderProductBlock(info)
      ]);
    });
    return $h("div", { class: renderConfig.listClass }, products).addClass("favourite-block");
  }

  function renderFavouriteBlock(renderConfig = {}) {
    var products = getProducts();
    if(!products.length)
      return $();

    renderConfig = Object.assign({}, config, renderConfig);

    return $h("div", { class: renderConfig.wrapperClass }, [
      tb.$h("div", [renderConfig.heading || t.blockHeadingOuterHtml || ""]).clone().contents(),
      renderFavouriteBlockInner(products, renderConfig)
    ]);
  }

  var $shareBtn, $productBlock, $emptyNotice, isViewingSharedFavourites = false;
  function initFavouritePage() {
    fetchProductsFromHash(location.hash).catch(function(err) {
      console.error(err);
      return [];
    }).then(function(products) {
      isViewingSharedFavourites = true;
      if(!products.length) {
        products = getProducts();
        isViewingSharedFavourites = false;
      }

      if($shareBtn)
        $shareBtn.remove();
      if($productBlock)
        $productBlock.remove();
      if($emptyNotice)
        $emptyNotice.remove();

      var $article = $(".content-inner > article");
      if(!products.length) {
        $emptyNotice = $h(".favourite-products-empty", [getStringCompat("emptyNoticeHtml")]).insertAfter($article);
        return;
      }

      if(!isViewingSharedFavourites)
        $shareBtn = renderShareBtn(products).insertBefore($article);
      $productBlock = renderFavouriteBlockInner(products).insertAfter($article);
      if(isViewingSharedFavourites)
        $productBlock.addClass("--view-only");
      else
        updateVisibleStaleProducts();

      $productBlock.find("img").unveil();
      tb.hooks.signalDomLoad();
    });
  }

  function isFavouritePage() {
    return !!$(getStringCompat("favouritePageSelector")).length;
  }

  let copiedTimeout;
  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      t = getStrings();
    },
    domReady: function() {
      $("body").on("click", ".favourite-products-toggle", function(e) {
        e.preventDefault();

        const $p = $(this).closest(".p,.p-detail");
        if(!$p.length)
          return;

        const isDetail = $p.is(".p-detail");
        const info = isDetail ? ProductInfo.getDetailProductInfo($p) : getProductBlockInfo($p);
        toggleFavouriteProduct(info, isDetail);
      });

      if(isFavouritePage()) {
        initFavouritePage();
        $(window).on("hashchange", initFavouritePage);
        $(window).on("scroll", updateVisibleStaleProducts);
      }

      $("body").on("click", ".favourite-products-share button", function(e) {
        e.preventDefault();
        const $btn = $(this);

        $("#favouriteProductsShareUrl").select();
        document.execCommand("copy");

        $btn.html(t.copyLinkBtnCopiedHtml);
        clearTimeout(copiedTimeout);
        copiedTimeout = setTimeout(function() {
          $btn.html(getStringCompat("copyLinkBtnHtml"));
        }, 2500);
      });
    },
    render: function() {
      var changed = false;
      changed |= !!updateProductBlocks();
      changed |= !!updateDetail();
      updateFavouriteCount();
      if(changed)
        tb.hooks.signalDomLoad();
    }
  });

  return {
    init, config, callbackPresets,
    isFavouriteProductFactory, toggleFavouriteProduct,
    getProducts, renderProductBlock, renderFavouriteBlock, renderFavouriteBlockInner,
    updateVisibleStaleProducts, isFavouritePage,
  };
})(tb.$h);

// === GoogleMaps.js ===
/** Inject Google Maps library and allow global access to ready event. */
const GoogleMaps = (function($h) {
  const config = {
    autoload: true,
    apiKey: "",
    libraries: "" // geometry
  };

  let ready$resolve;
  const ready = new Promise(resolve => ready$resolve = resolve);

  let loading = false;
  function load() {
    if(!loading) {
      loading = true;

      let url = "https://maps.googleapis.com/maps/api/js?";
      const params = [];
      params.push("key=" + config.apiKey);
      params.push("libraries=" + config.libraries);
      params.push("callback=initMap");
      url += params.join("&");

      window.initMap = window.initMap || (() => {});
      tb.hooks.hookFn("window.initMap", (initMap, args, context) => {
        initMap.apply(context, args);
        ready$resolve();
      });

      $(() => {
        $("head").append($h("script", { src: url, async: true }));
      });
    }

    return ready;
  }

  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      if(config.autoload)
        load();
    }
  });

  return { config, init, load, ready };
})(tb.$h);

// === LeftToFreeShippingFix.js ===
const LeftToFreeShippingFix = (function(AdvancedOrderHooks) {
  function updateDataLayer(content) {
    const $content = tb.$h("div", [content]),
      $delivery = $content.find(".extra.delivery > span");

    const cartInfo = getShoptetDataLayer("cartInfo");
    if(!cartInfo)
      return;
    const $priceLeft = $delivery.children("strong").first();
    if(!$priceLeft.length)
      return;
    const priceLeft = tb.common.parsePrice($priceLeft.text());

    if(isNaN(priceLeft))
      cartInfo.freeShipping = true;
    else {
      cartInfo.freeShipping = false;
      cartInfo.leftToFreeShipping.priceLeft = priceLeft;
      cartInfo.leftToFreeShipping.formattedPrice = priceLeft.ShoptetFormatAsCurrency();
    }
  }

  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      AdvancedOrderHooks.init(true);

      tb.hooks.hookFn("shoptet.tracking.updateDataLayerCartInfo", function(updateDataLayerCartInfo, args, context) {
        const response = args[0];

        const getNoBillingShippingPrice = response.getFromPayload("getNoBillingShippingPrice");
        const cartInfo = getShoptetDataLayer("cartInfo");
        if(cartInfo && getNoBillingShippingPrice)
          cartInfo.getNoBillingShippingPrice = getNoBillingShippingPrice;

        return updateDataLayerCartInfo.apply(context, args);
      });

      AdvancedOrderHooks.addContentFilter(function(content) {
        updateDataLayer(content);
        return content;
      });
    }
  });

  return { init };
})(AdvancedOrderHooks);

// === MessageDismissFix.js ===
const MessageDismissFix = (function() {
  const config = {
    manualDismissErrors: false
  };

  function appendDismissButtons() {
    $(".msg.msg-error").each(function() {
      if(tb.dom.oneTime(this, "MessageDismissFix"))
        $(this).append(tb.$h("button.msg__dismiss-btn", ["&times;"])).addClass("msg-dismissible");
    });
  }

  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      tb.hooks.hookFn("window.showMessage", function(showMessage, args, context) {
        clearTimeout(shoptet.runtime.dismiss);
        showMessage.apply(context, args);

        const type = args[1];
        if(config.manualDismissErrors && type === "error") {
          clearTimeout(shoptet.runtime.dismiss);
          appendDismissButtons();
        }
      });

      $("body").on("click", ".msg__dismiss-btn", function(e) {
        e.preventDefault();
        hideMsg(true);
      });
      $("body").on("click", function(e) {
        if($(".msg.msg-error").length && !$(e.target).closest(".msg").length)
          hideMsg(true);
      });
      $("html").on("click", ".msg.msg-dismissible", function(e) {
        e.stopImmediatePropagation();
      });
    }
  });

  return { config, init };
})();

// === ProductInfo.js ===
/** Extract product info from detail and render it as a product block. */
const ProductInfo = (function($h, $t) {
  const config = {
    defaultRenderOptions: {
      alwaysShowDetailBtn: false,
      showDescription: false,
      maxDescriptionLength: -1,
      showSku: true,
      showPrices: true,
      clonePriceSaveIntoBottom: true,
      showAvailability: true,
      showPriceAdditional: true,
      pricesVersion: 1,
    }
  };

  function getDetailProductInfo($detail) {
    const $form = $detail.is("#product-detail-form") ? $detail : $detail.find("#product-detail-form");

    function excludeProductBlocks() {
      return !$(this).closest(".p").length;
    }

    function getHiddenInput(name) {
      return $form.find("input[name=\"" + name + "\"]").filter(excludeProductBlocks).first().val();
    }

    function getMeta(prop) {
      var $el = $detail.find("[itemprop=\"" + prop + "\"]").filter(excludeProductBlocks).first();
      if($el.is("meta"))
        return $el.attr("content");
      if($el.is("link"))
        return $el.attr("href");
      return $el.text().trim();
    }

    var info = {};

    info.productId = getHiddenInput("productId");
    info.priceId = getHiddenInput("priceId");
    info.language = getHiddenInput("language");

    var metaKeys = [
      "name", "identifier", "url", "price", "priceCurrency",
      "availability", "description", "url", "warranty", "sku", "image",
      "ratingValue", "ratingCount"
    ];

    for(let key of metaKeys)
      info[key] = getMeta(key);

    const $productAppendix = $detail.find("h1 .product-appendix");
    if($productAppendix.length) {
      info.name = tb.dom.getTextShallow($productAppendix.parent()).trim();
      info.appendix = $productAppendix.text().trim();
    }

    info.descriptionHtml = $detail.find(".p-short-description").html();

    if(info.image)
      info.image = info.image.replace("/big/", "/detail/");

    function collectFlags(selector) {
      var $flags = $detail.find(selector).filter(excludeProductBlocks).filter(function() {
        return $(this).html().trim() !== "";
      }).first();
      return $flags.length ? $flags.html().trim() : "";
    }

    info.flagsDefault = collectFlags(".flags.flags-default");
    info.flagsExtra = collectFlags(".flags.flags-extra");

    info.ratingCount = info.ratingCount ? tb.common.parseNumber(info.ratingCount) : 0;
    info.ratingValue = info.ratingValue ? tb.common.parseNumber(info.ratingValue) : 0;

    info.showDetailBtn = false;
    var $availabilityValue = $detail.find(".availability-value").filter(excludeProductBlocks).first();
    if($availabilityValue.find(".choose-variant,.parameter-dependent").length) {
      info.showDetailBtn = true;
      $availabilityValue = $availabilityValue.find(".choose-variant,.parameter-dependent").first();
    }

    info.availabilityHtml = $availabilityValue.html();
    info.priceHtml = $detail.find(".p-final-price-wrapper").filter(excludeProductBlocks).html();

    info.timestamp = Date.now();

    return info;
  }

  function migrateFlags(info) {
    var $flags = tb.$h("div", [info.flags]),
      $flagsExtra = tb.$h("div", [$flags.find(".flag.flag-discount")]);

    info.flagsDefault = $flags.html().trim();

    var $prices = $h(".prices", [info.priceHtml]);
    if($prices.find(".price-save").length && !$flagsExtra.find(".flag.flag-discount").length)
      $flagsExtra.append(tb.$h("span.flag.flag-discount", [
        $prices.find(".price-standard"),
        $prices.find(".price-save")
      ]));

    info.flagsExtra = $flagsExtra.html().trim();
  }

  function renderProductBlock(info, options) {
    options = Object.assign({}, config.defaultRenderOptions, options);

    var $prices, $starsWrapper, $stars, $availability, $tools, $flagsDefault, $flagsExtra;
    $availability = $h(".availability", [
      info.availabilityHtml
    ]);

    if(!options.showAvailability)
      $availability.empty();

    if(info.ratingCount > 0) {
      $starsWrapper = $h(".stars-wrapper", {
        "data-micro-rating-value": info.ratingValue,
        "data-micro-rating-count": info.ratingCount
      }, [
        $stars = $h("span.stars.stars-list")
      ]);
      for(let i = 1; i <= 5; i++)
        $stars.append($h("span.star")
          .toggleClass("star-on", info.ratingValue >= i)
          .toggleClass("star-off", info.ratingValue < i));
    } else
      $starsWrapper = $(".stars-placeholder");

    $prices = $h(".prices", [info.priceHtml]);

    if(options.pricesVersion >= 2) {
      let $priceFinalHolder = $prices.find(".price-final-holder.default-variant");
      if(!$priceFinalHolder.length)
        $priceFinalHolder = $prices.find(".price-final-holder");
      let $priceAdditional = $prices.find(".price-additional .default-variant");
      if(!$priceAdditional.length)
        $priceAdditional = $prices.find(".price-additional");
      if($priceAdditional.length) {
        if($priceAdditional.find(".nowrap").length)
          $priceAdditional.html($priceAdditional.html().replace(/<span class="nowrap">([^<]+)<\/span>\s*/, "$1&nbsp;").trim());
        else
          $priceAdditional.html($priceAdditional.html().replace(/\s+(bez DPH)/, "&nbsp;$1").trim());
      }
      $priceFinalHolder.html($priceFinalHolder.html().replace(/([^<]+)<span class="nowrap">([^<]+)<\/span>/, ($0, $1, $2) => `<small>${$1.trim()}</small> ${$2}`));
      $prices.html([
        options.showPriceAdditional && $priceAdditional.length ? $h(".price-additional", $priceAdditional.contents()) : null,
        $h(".price.price-final", { "data-testid": "productCardPrice" }, [
          $h("strong", $priceFinalHolder.contents()),
        ]),
      ]);
    } else {
      $prices.find(".price-measure").remove();
      $prices.find(".detail-prices").unwrap();
      $prices.find(".price-final").addClass("price");
    }

    if(!options.clonePriceSaveIntoBottom) {
      // those are in .flag.flag-discount
      $prices.find(".price-standard,.price-save").remove();
    }

    if(!options.showPrices)
      $prices.empty();

    $tools = $h(".p-tools");

    if(info.showDetailBtn || options.alwaysShowDetailBtn)
      $tools.append($h("a.btn.btn-primary", { href: info.url }, "Detail"));
    else
      $tools.append($h("form.pr-action", {
        action: "/action/Cart/addCartItem/",
        method: "post"
      }, [
        createHiddenInput("language", info.language),
        createHiddenInput("priceId", info.priceId),
        createHiddenInput("productId", info.productId),
        $h("button.btn.btn-cart.add-to-cart-button", {
          type: "submit"
        }, [
          $h("span", "Do košíku")
        ])
      ]));

    function createHiddenInput(name, value) {
      return $h("input", { type: "hidden", name, value });
    }

    function truncate(str, maxLength, append) {
      str = str.trim();
      if(str.length < maxLength)
        return str;

      var parts = str.split(/([ ,.:;"'_-])/);
      parts.push(""); // word,delimiter

      let res = "", lastDelimiter = "";
      for(let i = 0; i < parts.length; i += 2) {
        let nextWord = "";
        for(; i < parts.length; i += 2) {
          nextWord += parts[i];
          if(parts[i] !== "")
            break;
          else
            nextWord += parts[i + 1];
        }

        if(res.length + lastDelimiter.length + nextWord.length + append.length > maxLength)
          break;

        res += lastDelimiter + nextWord; // append first word, but not its delimiter
        lastDelimiter = parts[i + 1];
      }

      return res.length ? (res + append) : "";
    }

    let description = $h("div", [info.description]).text(); // convert html to text
    if(options.maxDescriptionLength > -1)
      description = truncate(description, options.maxDescriptionLength, "...");
    else if(info.descriptionHtml)
      description = [info.descriptionHtml];

    if(info.flags && !info.flagsDefault && !info.flagsExtra)
      migrateFlags(info);

    if(info.flagsDefault)
      $flagsDefault = $h(".flags.flags-default", [info.flagsDefault]);
    if(info.flagsExtra)
      $flagsExtra = $h(".flags.flags-extra", [info.flagsExtra]);

    return $h(".p", {
      "data-micro": "product",
      "data-micro-product-id": info.productId,
      "data-micro-identifier": info.identifier
    }, [
      $h("a.image", { href: info.url }, [
        $h("img", {
          src: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
          "data-src": info.image,
          alt: info.name,
          "data-micro-image": info.image
        }),
        $flagsDefault,
        $flagsExtra
      ]),
      $h(".p-in", [
        $h(".p-in-in", [
          $h("a.name", {
            href: info.url,
            "data-micro": "url"
          }, [
            $h("span", { "data-micro": "name" }, [
              $t(info.name),
              ...(info.appendix ? [
                " ", // space between name and appendix when selecting the whole title
                $h("span.category-appendix", info.appendix),
              ] : []),
            ])
          ]),
          $h(".ratings-wrapper", [$starsWrapper, $availability])
        ]),
        $h(".p-bottom", [
          $h("div", {
            "data-micro": "offset",
            "data-micro-price": info.price,
            "data-micro-price-currency": info.priceCurrency,
            "data-micro-warranty": info.warranty,
            "data-micro-availability": info.availability
          }, [
            $prices,
            $tools,
            options.showDescription ? $h(".p-desc", { "data-micro": "description" }, description) : null
          ])
        ])
      ]),
      options.showSku ? $h(".p-code", [
        "Kód: ",
        $h("span", { "data-micro": "sku" }, info.sku)
      ]) : $h("span.no-display", { "data-micro": "sku" }, info.sku)
    ]);
  }

  function init() {

  }

  return { init, config, getDetailProductInfo, renderProductBlock };
})(tb.$h, tb.$t);

// === RecentProductsLib.js ===
/** Store recently viewed products and display them later. */
const RecentProductsLib = (function($h, ProductInfo) {
  const config = {
    storageKey: "recentProducts",
    newestFirst: false,
    alwaysShowDetailBtn: false,
    limit: -1,
    maxLifetime: -1,
    maxDescriptionLength: -1,
    wrapperClass: "products-recent-wrapper",
    heading: $h("h2.products-recent-header", "Naposledy jste prohlíželi"),
    listClass: "products products-block products-recent products-additional p-switchable",
    itemClass: "product col-sm-6 col-md-12 col-lg-6 active related-sm-screen-show",
  };

  function getProducts() {
    return JSON.parse(localStorage.getItem(config.storageKey) || "[]");
  }

  function setProducts(products) {
    localStorage.setItem(config.storageKey, JSON.stringify(products));
  }

  function truncateList(list) {
    if(config.maxLifetime > -1) {
      var now = Date.now();
      list = list.filter(function(info) {
        return info.timestamp && now - info.timestamp <= config.maxLifetime;
      });
    }
    if(config.limit > -1)
      list = list.slice(-config.limit);

    return list;
  }

  function storeCurrentProduct() {
    var info = ProductInfo.getDetailProductInfo($(".p-detail"));

    var list = getProducts();
    list = list.filter(function(p) {
      return p.productId !== info.productId || p.priceId !== info.priceId;
    });
    list.push(info);

    list = truncateList(list);
    setProducts(list);
  }

  function renderRecentlyViewedBlock() {
    var list = getProducts();
    list = truncateList(list);

    if(!list.length)
      return $();

    if(config.newestFirst)
      list = list.reverse();

    var products = list.map(function(info) {
      return $h("div", { class: config.itemClass }, [
        ProductInfo.renderProductBlock(info, config)
      ]);
    });

    return $h("div", { class: config.wrapperClass }, [
      config.heading,
      $h("div", { class: config.listClass }, products)
    ]);
  }

  var init = tb.dom.createModuleInitializer({
    earlyInit() {
      if($("body.type-detail").length)
        storeCurrentProduct();
    },
  });

  return {
    init, config,
    renderRecentlyViewedBlock,
  };
})(tb.$h, ProductInfo);

// === ReplaceResponsiveNavBtn.js ===
/** Replace html of hamburger button of .responsive-nav to allow styling. */
const ReplaceResponsiveNavBtn = (function() {
  const config = {
    newHtml: ""
  };

  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      if(!$.fn.shpResponsiveNavigation)
        return;
      tb.hooks.hookFn("$.fn.shpResponsiveNavigation", function(shpResponsiveNavigation, args, context) {
        shpResponsiveNavigation.apply(context, args);

        function updateNavBtn() {
          context.find(".navigation-btn").html(config.newHtml);
        }
        $(window).resize(updateNavBtn);
        updateNavBtn();
        return context;
      });
    }
  });

  return { config, init };
})();

// === ResponsiveSubmenuHoverFix.js ===
/** Fix responsive submenu activating on hover. */
const ResponsiveSubmenuHoverFix = (function() {
  const init = tb.dom.whenReady(function init() {
    $("body").on("mouseover", "#navigation .ext", function(e) {
      if(!detectResolution(shoptet.abilities.config.navigation_breakpoint)) {
        e.stopPropagation();
      }
    });
  });

  return { init };
})();

// === SeoBanners.js ===
/** Use banners as snippets, optionally removing them after load. */
const SeoBanners = (function() {
  const config = {
    idMap: {},
    indexMap: {},
    clone: true, // clone on load
    remove: false // remove from DOM after initial load
  };

  let banners;
  function loadFromDom() {
    var $footer = $("#footer .custom-footer");
    if(banners || !$footer.length)
      return;

    let $toDelete = $();
    banners = {};

    for(let key in config.idMap) {
      const id = config.idMap[key];
      const $banner = $footer.find("[data-ec-promo-id=\"" + id + "\"]").closest(".banner");
      banners[key] = config.clone ? $banner.clone() : $banner;
      $toDelete = $toDelete.add($banner);
    }

    for(let key in config.indexMap) {
      var index = config.indexMap[key],
        $banner = $footer.children().eq(index);
      banners[key] = config.clone ? $banner.clone() : $banner;
      $toDelete = $toDelete.add($banner);
    }

    if(config.remove)
      $toDelete.detach();
  }

  function get(key, clone = true) {
    loadFromDom();

    if(key) {
      const $banner = banners?.[key] || $();
      return clone ? $banner.clone() : $banner;
    }

    return banners;
  }

  const init = tb.dom.createModuleInitializer({
    render() {
      if(config.remove)
        loadFromDom();
    }
  });

  return { config, init, get, };
})();

// === SlickUnveilFix.js ===
/** Fix image lazy load inside of slick. */
const SlickUnveilFix = (function() {
  const init = tb.dom.whenReady(function init() {
    $("html").on("init reInit", ".slick-slider", function() {
      $(this).find("img").unveil();
    });
    $("html").on("beforeChange afterChange", ".slick-slider", function() {
      $(window).trigger("lookup.unveil");
    });
  });

  return { init };
})();

const modules = {
AdvancedOrderHooks,
AjaxSubmitFormHooks,
CarrierRemark,
CartItemData,
DelayedCart,
DetailHooks,
ExternalRenderEvents,
FavouriteProducts,
GoogleMaps,
LeftToFreeShippingFix,
MessageDismissFix,
ProductInfo,
RecentProductsLib,
ReplaceResponsiveNavBtn,
ResponsiveSubmenuHoverFix,
SeoBanners,
SlickUnveilFix,
};

  tb.modules = tb.m = modules;

})(window.toolbox);
